module.exports = __webpack_public_path__ + "img/icon-success.1864964d.svg";